import Vue from 'vue';

Vue.filter('address', function(parcel){
	let str = '';
	if (parcel.address && parcel.address.street && parcel.address.street.name){
		if (parcel.address.street.number !== null) str += parcel.address.street.number+' ';
		if (parcel.address.street.numberFraction !== null) str += parcel.address.street.numberFraction+' ';
		if (parcel.address.street.preDirection !== null) str += parcel.address.street.preDirection+' ';
		if (parcel.address.street.name !== null) str += parcel.address.street.name+' ';
		if (parcel.address.street.suffix !== null) str += parcel.address.street.suffix+' ';
		if (parcel.address.street.postDirection !== null) str += parcel.address.street.postDirection+' ';
		if (parcel.address.unit !== null) str += ' #'+parcel.address.unit;
		str = str.replace(/\s+$/, '')
	} else {
		str = parcel.apnFmt? parcel.apnFmt: 'no apn';
	}
	return str;
});


// WEBPACK FOOTER //
// ./src/filters/parcel.js